/**
 * The patient list on this branch is the POC list (v2). The download button stays to the
 * right of Add Patient. The `patient_list_v3` flag no longer hides that layout.
 */
export const usePatientListFeatureFlag = () => {
  return {
    isPatientListV2Enabled: true
  };
};
